"use client";

import { useI18n } from "@wojo/localization";
import { useBookedGroupMembersTrips } from "./_client/hooks/use-booked-group-members-trips";
import { useGroupMembersProspects } from "./_client/hooks/use-group-members-prospects";
import { notFound } from "next/navigation";
import { MembersOverview } from "./_components/members-overview/MembersOverview";
import { NoBookingsInfoCard } from "./_components/no-bookings-info-card/NoBookingsInfoCard";
import { BookedTravelers } from "./_components/booked-travelers/BookedTravelers";
import { InterestedTravelers } from "./_components/interested-travelers";
import { CanceledTravelers } from "./_components/canceled-travelers";

export type MyGroupMembersProps = {
    gcDepartureId: string;
};

export const MyGroupMembers: React.FC<MyGroupMembersProps> = ({
    gcDepartureId,
}) => {
    const { gcDeparture } = useBookedGroupMembersTrips(gcDepartureId);
    const { gcDepartureProspects } = useGroupMembersProspects(gcDeparture?._id);
    const canceledTrips = gcDeparture?.cancelledTrips || [];
    const i18n = useI18n("account").account;
    const myGroupMembersEnabled = !!i18n.navigation.booking.myGroupMembers;
    if (!myGroupMembersEnabled || !gcDeparture) {
        notFound();
    }

    if (!gcDeparture.departure) {
        throw new Error("Group members failed to load");
    }

    const bookedTravelers = [
        ...(gcDeparture.confirmedTrips || []),
        ...(gcDeparture.requestedTrips || []),
    ];

    const hasExtension = !!gcDeparture.departure.activeExtension;
    return (
        <>
            <MembersOverview
                gcDeparture={gcDeparture}
                gcDepartureProspects={gcDepartureProspects}
                hasExtension={hasExtension}
            />
            {gcDeparture.nbTravelersConfirmed === 0 ? (
                <NoBookingsInfoCard />
            ) : (
                <BookedTravelers
                    departure={gcDeparture.departure}
                    bookedTravelers={bookedTravelers}
                    hasExtension={hasExtension}
                />
            )}
            <InterestedTravelers
                gcDepartureProspects={gcDepartureProspects}
                gcDepartureId={gcDeparture._id}
                groupCoordinatorCustomerId={
                    gcDeparture.groupCoordinatorCustomerId
                }
            />
            <CanceledTravelers canceledTrips={canceledTrips} />
        </>
    );
};
